<template>
  <div class="left-sidebar pa-6">
    <TemplateLink
      v-if="!isTemplate && jobProfile?.last_applied_template_ulid"
      class="mb-4"
    />
    <ProfileLink
      v-if="jobProfile?.hris_reference"
      :profile="jobProfile.hris_reference"
      :is-hris-profile="true"
      class="mb-4"
    />
    <ProfileLink
      v-for="draft in jobProfile?.draft_profiles"
      :key="draft.ulid"
      :profile="draft"
      class="mb-4"
    />
    <HrisProfileLinkCandidates
      v-if="!isHrisProfile && !isTemplate && !jobProfile?.hris_reference"
      class="mb-4"
    />
    <GuidanceList
      class="mb-4"
      :body-messages="profileGuidanceMessages"
      :is-revision-saving="false"
      :hide-actions="true"
      :hide-categories="['brand', 'performance']"
    >
      <template #custom-action="{ message }">
        <div v-if="message.action === 'custom_summary'">
          <FirstDraftButton
            small
            variant="plain"
            @click="generateSummary"
          >
            Generate Job Summary
          </FirstDraftButton>
        </div>
      </template>

      <template
        v-if="!isHrisProfile"
        #append-icon="{ message }"
      >
        <template
          v-for="generatorType in [
            'responsibilities',
            'skills',
            'experience',
            'competencies',
            'education',
            'certifications',
          ]"
          :key="generatorType"
        >
          <FirstDraftButton
            v-if="message.action === `custom_${generatorType}`"
            :disabled="rescorePending"
            small
            variant="plain"
            width="30px"
            min-width="30px"
            @click="generateButtonClick(generatorType)"
          />
        </template>
      </template>
    </GuidanceList>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useModals } from '@/stores/modals/modals';
import TemplateLink from '@/components/jobProfiles/editor/TemplateLink.vue';
import ProfileLink from '@/components/jobProfiles/editor/ProfileLink.vue';
import HrisProfileLinkCandidates from '@/components/jobProfiles/editor/HrisProfileLinkCandidates.vue';
import GuidanceList from '@ui/components/editor/GuidanceList/GuidanceList.vue';
import FirstDraftButton from '@ui/components/firstDraft/FirstDraftButton.vue';

const {
  isTemplate,
  isHrisProfile,
  rescorePending,
  jobProfile,
  profileGuidanceMessages,
  fields,
} = storeToRefs(useCurrentJobProfile());

const { setModal } = useModals();

const generateSummary = () => {
  setModal({ field: 'generateSummaryConfirm', value: true });
};

const generateButtonClick = (generatorType) => {
  const field = fields.value.find((f) => f.content_generator_type === generatorType);
  if (!field) return;

  setModal({
    field: 'generateFieldContentConfirm',
    value: true,
    params: { fieldTitle: field.label, generatorType },
  });
};
</script>
